module.exports = __webpack_public_path__ + "media/images/vp/icon.menu.events.black-d5f6b185c3072ce8de707b6c69f65e92.svg";